import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings";
import {
    WORKLOAD_TITLE_INSIDE_NO_TRUNCATE,
    WORKLOAD_TITLE_INSIDE_TRUNCATE, WORKLOAD_TITLE_OUTSIDE
} from "../../../gd-modules/workload/manager/const";

const fieldsConfig = {

    'labelPosition': {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : WORKLOAD_TITLE_OUTSIDE,
        options         : [WORKLOAD_TITLE_INSIDE_TRUNCATE,WORKLOAD_TITLE_INSIDE_NO_TRUNCATE,WORKLOAD_TITLE_OUTSIDE]
    },

}

export default class UserSettingsViewsWorkload extends ServerSettings {

    constructor(config:any) {

        super(config, fieldsConfig);

        // auto init all settings
        _.forEach(fieldsConfig, (value,key)=>{
            // @ts-ignore
            this[key] = this.initValue(key)
        })
    }


    toJson() {
        const result = {};

        // auto save all settings
        _.forEach(fieldsConfig, (value,key)=>{
            this.valueToJson(result, key)
        })

        return result;
    }
}
